const VERSION = '2.0.18a'
export default VERSION
